<template>
  <div class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px]">
   <!-- Form item -->
   <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <div class="w-[5px] h-[5px] bg-v-ui-root-service-alarm rounded-full required-indicator"></div>
        Наименование
      </div>
      <div class="relative">
        <VInput v-model="nosologyFormData.name" placeholder="Введите название нозологии" contentWidth @blur="validateName" :error="!isNameValid" />
        <div v-if="!isNameValid" class="note-12-reg-400 text-v-ui-root-service-alarm mt-[4px]"> Заполните обязательное поле </div>
      </div>
    </div>
    <!-- End form item -->

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        Описание
      </div>
      <VTextArea v-model="nosologyFormData.description" placeholder="Добавьте описание" size="m" resizable />
    </div>
    <!-- End form item -->

   <!-- Form item -->
   <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <div class="w-[5px] h-[5px] bg-v-ui-root-service-alarm rounded-full required-indicator"></div>
        Диагнозы МКБ
      </div>
        <VSelector
          :value="nosologyFormData.diagnoses"
          :items="preparedDiagnoses"
          absolute
          variant="gray"
          multiselect
          with-search
          infiniteScroll
          isEmitSearch
          hideSelectAll
          :isInfiniteLoading="isInfiniteLoading"
          :isEmitSrcLoading="isEmitSrcLoading"
          @load-more="loadMoreMkb"
          @update:searchStr="getMkbFromSearch"
          @input="(value) => nosologyFormData.diagnoses = value"
        />
    </div>
    <!-- End form item -->

    <!-- Buttons -->
    <div class="flex justify-start gap-x-[8px]">
      <VButton type="light" size="m" @click="openBackDialog" :label="backButtonLabel" />
      <VButton size="m" @click="saveHandler" :label="saveButtonLabel" :disabled="saveButtonDisabled" />
    </div>
    <!-- End buttons -->

    <!-- Back dialog -->
    <VDialog
     v-model="isBackDialogOpen"
     :title="dialogConfig.title"
     :subtitle="dialogConfig.subtitle"
     :leftButton='dialogConfig.leftButton'
     :rightButton='dialogConfig.rightButton'
    />
    <!-- End back dialog -->
  </div>
</template>

<script>
import { VInput, VTextArea, VSelector, VButton, VDialog } from '@gostelemed.front/rt-doctis.designsystem';
import nosologyService from '@/services/nosology/nosology.service';
import { TOASTS } from '@/services/core/ui/toasts.const';

export default {
  name: 'NosologyForm',
  components: {
    VInput,
    VTextArea,
    VSelector,
    VButton,
    VDialog,
  },
  props: {
    nosology: {
      type: Object,
      default: () => ({}),
    },
    diagnoses: {
      type: Array,
      default: () => [],
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    backBtnActive: {
      type: Boolean,
      default: false,
    },
    isInfiniteLoading: {
      type: Boolean,
      default: false
    },
    isEmitSrcLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isNameValid: true,
      isBackDialogOpen: false,
      isRequestProcessing: false,
      nosologyFormData: {
        name: null,
        description: '',
        diagnoses: []
      },
      preparedDiagnoses: [],
    }
  },
  watch: {
    backBtnActive(newVal) {
      if (newVal) {
        this.openBackDialog();
      }
    },
    diagnoses: {
      immediate: true,

      handler(newDiagnoses) {
        this.preparedDiagnoses = newDiagnoses.map((diagnosis) => ({
          ...diagnosis,

          title: `${diagnosis.code}`,

          multiselect: true,

          id: diagnosis.code,
        }));
      },
  },
  },
  computed: {
    dialogConfig() {
      if (this.editMode) {
        return {
          title: 'Редактирование нозологии',
          subtitle: 'Вы хотите прервать редактирование? Изменения не сохранятся.',
          leftButton: { label: 'Прервать', handler: () => this.confirmCancelHandler() },
          rightButton: { label: 'Не прерывать', handler: () => this.closeBackDialog() },
        };
      }
      return {
        title: this.editMode ? 'Редактирование нозологии' : 'Добавление нозологии',
        subtitle: this.editMode ? 'Вы хотите прервать редактирование нозологии? Введённые данные не сохранятся.' : 'Вы хотите прервать добавление нозологии? Введённые данные не сохранятся.',
        leftButton: { label: 'Прервать', handler: () => this.confirmBackHandler() },
        rightButton: { label: 'Не прерывать', handler: () => this.closeBackDialog() },
      };
    },
    backButtonLabel() {
      return this.editMode ? 'Отменить' : 'Назад';
    },
    saveButtonLabel() {
      return this.editMode ? 'Сохранить изменения' : 'Добавить';
    },
    saveButtonDisabled() {
      return !this.nosologyFormData.name || !this.nosologyFormData.diagnoses.length || this.isRequestProcessing;
    },
  },
  mounted() {
    if (this.editMode && this.nosology?.name) {
      this.nosologyFormData = {...this.nosology};
      this.nosologyFormData.diagnoses = this.nosology.diagnoses.map((diagnosis) => ({
        id: diagnosis.id,
        title: diagnosis.mkbCode,
        multiselect: true,
        code: diagnosis.mkbCode,
      }));
    }
    if (this.diagnoses) {
      this.preparedDiagnoses = this.diagnoses.map((diagnosis) => ({
        ...diagnosis,
        title: `${diagnosis.code}`,
        multiselect: true,
        id: diagnosis.code
      }));
    }
  },
  methods: {
    openBackDialog() {
      this.isBackDialogOpen = true;
    },
    closeBackDialog() {
      this.isBackDialogOpen = false;
      this.$emit('update:backBtnActive', false);
    },
    confirmBackHandler() {
      this.$router.push('/remote-monitoring/kzs/nosology');
    },
    confirmCancelHandler() {
      this.isBackDialogOpen = false;
      this.$emit('cancel');
    },
    async saveHandler() {
      this.isRequestProcessing = true;
      const resultNosologyParams = {
        name: this.nosologyFormData.name,
        description: this.nosologyFormData.description,
        diagnoses: this.nosologyFormData.diagnoses.map((diagnosis) => diagnosis.code),
      };
      if (this.editMode) {
        await this.updateNosology(resultNosologyParams);
      } else {
        await this.createNosology(resultNosologyParams);
      }
      this.isRequestProcessing = false;
    },
    async updateNosology(resultNosologyParams = {}) {
      try {
        const updatedNosology = await nosologyService.updateNosology(this.nosology.id, resultNosologyParams);
        if(updatedNosology) {
          this.$uiService.showToast(TOASTS.NOSOLOGY_UPDATE_SUCCESS);
          this.$emit('updateNosology', updatedNosology);
        } else {
          this.$uiService.showToast(TOASTS.NOSOLOGY_UPDATE_ERROR);
        }
      } catch (error) {
        console.error('Ошибка при обновлении нозологии:', error);
        this.$uiService.showToast(TOASTS.NOSOLOGY_UPDATE_ERROR);
      } finally {
        this.isRequestProcessing = false;
      }
    },
    async createNosology(resultNosologyParams = {}) {
      try {
        const response = await nosologyService.createNosology(resultNosologyParams);
        if (response) {
          this.$uiService.showToast(TOASTS.NOSOLOGY_CREATE_SUCCESS);
          this.$router.push(`/remote-monitoring/kzs/nosology/${response.id}`);
        } else {
          this.$uiService.showToast(TOASTS.NOSOLOGY_CREATE_ERROR);
        }
      } catch (error) {
        console.error('Ошибка при создании нозологии:', error);
        this.$uiService.showToast(TOASTS.NOSOLOGY_CREATE_ERROR);
      } finally {
        this.isRequestProcessing = false;
      }
    },
    validateName() {
      if (!this.nosologyFormData.name) {
        this.isNameValid = false;
      } else {
        this.isNameValid = true;
      }
    },
    loadMoreMkb() {
      this.$emit('loadMoreMkb');
    },
    getMkbFromSearch(value) {
      this.$emit('getMkbFromSearch', value);
    }
  },
}
</script>
